    export const generateHexColor = () => {
        return (
            '#' +
            Math.floor(Math.random() * 16777215)
                .toString(16)
                .padStart(6, '0')
        );
    };

    export const colorPalette = [
        '#9d69b7',
        '#1b63aa',
        '#009ee3',
        '#28347c',
        '#84d381',
        '#5eb3a6',
        '#576af0',
        '#e85d9e', // Magenta Pink
        '#6c4fb7', // Deep Purple
        '#4b9fd9', // Sky Blue
        '#2d8bb5', // Ocean Blue
        '#7ac943', // Lime Green
        '#45b69c', // Turquoise
        '#8b7de8', // Lavender
        '#1a4d7a', // Steel Blue
        '#b384d3', // Soft Purple
        '#00bfa5', // Aqua Green
        '#5d4fc7', // Royal Purple
        '#3ea89d', // Jade
        '#92d050', // Yellow Green
        '#4680d9', // Cornflower Blue
        '#a666cc', // Orchid
    
        ];


    export function sumByKey<T>(items: T[] | undefined | null, key: keyof T): number {
            if (!items) return 0;

            return items.reduce((sum, item) => {
                const value = Number(item[key]);
                return sum + (isNaN(value) ? 0 : value);
            }, 0);
            }

    /**
     * Groups an array by a specific key and sums up a value field.
     * @param items - The array of data
     * @param groupByKey - The field to group by (e.g., 'company_name')
     * @param valueKey - The field to sum up (e.g., 'paycheck_count')
     */
    export function sumByGroup<T>(
        items: T[] | undefined | null, 
        groupByKey: keyof T, 
        valueKey: keyof T
        ): Record<string, number> {
            
            if (!items) return {};

            return items.reduce((acc, item) => {
                // Get the key (e.g., "Google")
                const groupName = String(item[groupByKey]);
                
                // Get the value safely
                const value = Number(item[valueKey]);
                const safeValue = isNaN(value) ? 0 : value;

                // Add to existing group total
                acc[groupName] = (acc[groupName] ?? 0) + safeValue;
                
                return acc;
            }, {} as Record<string, number>);
        }

    export function calculatePercentage(value: number, total: number): string {
            // Convert to numbers to be safe against strings/nulls
            const safeValue = Number(value) || 0;
            const safeTotal = Number(total) || 0;

            return safeTotal > 0 
                ? ((safeValue / safeTotal) * 100).toFixed(2) 
                : '0.00';
        }